import * as tsx from 'vue-tsx-support';
import { Course } from '@/models';
import { CoursesStore, SiteSettingsStore } from '@/store';
import * as utils from '@/utils';
/**
 * Gets the appropriate URL for the CodeGrade documentation website.
 *
 * This function determines whether to link to the student-specific or the general
 * documentation based on the user's role in the course associated with the
 * current route. It also appends the current application version to the URL.
 *
 * @param route The current Vue Router route object.
 * @returns The documentation URL string.
 */
export function getDocumentationLink(route) {
    const course = utils
        .maybeParseOrKeepFloat(route.params.courseId)
        .chain(CoursesStore.getCourse());
    const isStudent = course.filter(c => c instanceof Course).mapOrDefault(c => c.isStudent, false);
    const version = SiteSettingsStore.releaseInfo().mapOrDefault(r => r.version ?? `#${r.commit.substring(0, 7)}`, '...');
    const documentationUrl = isStudent
        ? `https://help.codegrade.com/for-students/getting-started?v=${version}`
        : `https://help.codegrade.com/?v=${version}`;
    return documentationUrl;
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export default tsx.componentFactoryOf().create({
    name: 'help-homepage-link',
    functional: true,
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    render(_, ctx) {
        const documentationUrl = getDocumentationLink(ctx.parent.$route);
        return (<a target="_blank" {...ctx.data} class={[ctx.data.class, ctx.data.staticClass]} href={documentationUrl} style={[ctx.data.staticClass, ctx.data.class]}>
                {utils.renderScopedSlot({}, ctx.scopedSlots.default, () => 'Help')}
            </a>);
    },
});
